export enum HttpRequestHeader {
  Authorization = 'Authorization',
  ApplicatioName = 'Application-Name',
  RestaurantRefId = 'RestaurantRefId',
  CacheControl = 'Cache-Control',
  Pragma = 'Pragma',
  Expires = 'Expires',
  xFeatureAccess = 'x-feature-access',
}
